module.exports = __webpack_public_path__ + "img/orange_085.391a61b2.png";